export default __webpack_public_path__ + "media/zurb/img/services/process/copilots-image-0383ab054908af2193cedb3047d535ef.png";